const Styles = {
  cardStyle: {
    height: "100%",
    position: "relative",
  },
  textfieldStyle: {
    width: "90%",
  },
  dropdownfieldStyle: {
    width: "90%",
  },
  gridContainerStyle: {
    padding: 10,
  },
  dropdownfieldStyleOrg: {
    marginTop: 10,
    marginBottom: 10,
  },
  buttonStyle: {
    backgroundColor: "#F5F5F5",
    borderRadius: 5,
    marginLeft: "2%",
    color: "#616161",
    height: 25,
    width: 250,
    position: "relative",
    textTransform: "none",
  },
  buttonStyleAdvance: {
    backgroundColor: "#F5F5F5",
    borderRadius: 5,
    marginLeft: "2%",
    color: "#616161",
    height: 25,
    width: 150,
    position: "relative",
    textTransform: "none",
  },
  buttonStyleRefresh: {
    backgroundColor: "#F5F5F5",
    borderRadius: 5,
    color: "#616161",
    height: 25,
  },
  buttonStyleSubmit: {
    backgroundColor: "#FF0000",
    borderRadius: 5,
    marginTop: "4%",
    marginBottom: "4%",
    marginLeft: "2%",
    color: "#FFFFFF",
    height: 25,
    width: 100,
    textTransform: "none",
  },
  divOrganizationStructure: {
    padding: "0px 30px 20px 20px",
  },
  container: {
    // width: "100%",
    // height: "100%",
    padding: "24px",
    backgroundColor: "#fff",
  },
  filter: {
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: "1rem",
  },
  left: {
    display: "flex",
    gap: "1rem",
  },
  right: {
    display: "flex",
    gap: ".6rem",
  },
  reload: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#E6E6E6",
    borderRadius: 5,
    cursor: "pointer",
    padding: "6px",
  },
  main: {
    borderRadius: 8,
    marginBottom: "1rem",
    height: "100%",
  },
  initialContent: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  text: {
    fontWeight: 400,
    fontSize: 18,
    color: "#171B5E",
    textAlign: "center",
    marginTop: 10,
  },
  filterWrapper: {
    padding: "1rem 0",
    display: "flex",
    justifyContent: "space-between",
  },
  filterContainer: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    gap: 8,
  },
  clearAll: {
    fontWeight: 500,
    fontSize: 14,
    color: "#0000FF",
    cursor: "pointer",
  },
  pagination: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    margin: "30px 0",
    padding: "0 1rem",
  },
  totalSize: {
    fontSize: 14,
    fontWeight: 500,
    color: "#616161",
  },
  totalElements: {
    fontWeight: 500,
    fontSize: 14,
    textAlign: "end",
  },
};
export default Styles;
